import { type ComponentProps, type ReactNode } from "react";
import { Button } from "@zapier/design-system";
import { useTemplateCreation } from "src/hooks/useTemplateCreation";
import classNames from "classnames";
import styles from "./TryTemplateButton.module.css";
import { Template } from "src/types";

export const COPILOT_QUERY_PARAM = "copilot_prompt";
export const COPILOT_PROMPT = "Help finish setting up my Zap";

export type tryTemplateActions = {
  hasCreationScreen: boolean;
  createTemplate: (templateKey: string) => void;
  creationError: string | null;
  setCreationError: (error: string | null) => void;
};

type Props = {
  children: ReactNode;
  products: Template["products"];
  webIntentUrl?: string;
  slug: string;
  tryTemplateActions: tryTemplateActions;
  onClick?: () => void | ComponentProps<"button">["onClick"];
  size?: "small" | "medium";
  allowMobileFullWidth?: boolean;
} & ComponentProps<"button"> &
  ComponentProps<typeof Button>;

export const TryTemplateButton = ({
  children,
  slug,
  webIntentUrl,
  products,
  tryTemplateActions,
  onClick,
  size = "medium",
  allowMobileFullWidth = false,
}: Props) => {
  const { createTemplate, createTemplateAndNavigate, renderCreationUI } =
    useTemplateCreation({
      tryTemplateActions,
      webIntentUrl,
      slug,
      products,
    });

  return (
    <>
      {renderCreationUI()}
      <div
        className={classNames(styles.buttonWrapper, {
          [styles.allowMobileFullWidth]: allowMobileFullWidth,
        })}
      >
        <Button
          size={size}
          onClick={() =>
            createTemplateAndNavigate({
              slug,
              webIntentUrl,
              createTemplate,
              onClick,
            })
          }
        >
          {children}
        </Button>
      </div>
    </>
  );
};
